import React from 'react';
import CrimeDetail from './CrimeDetail';
import MyAppBar from './component/AppBar';
import { Switch, Route } from 'react-router-dom'
import CrimeList from './CrimeList';
import AboutApp from './AboutApp';
import SignIn from './SignIn';
import SendingDialog from './component/SendingDialog';
import API from './helper/API';
import User from './model/User';

import { Snackbar } from '@material-ui/core';


const App: React.FC = () => {
  const user = new User();
  const [isUploading, setLoading] = React.useState<boolean>(false);
  const [snackMsg, setSnackMsg] = React.useState<string>("")

  React.useEffect(() => {
    // Проверка обновления базы объектов
    API.updateSubjectConfig(true).then((msg: string) => {
      if (msg !== "") {
        setSnackMsg(msg)
      }
    });
  }, [user.subjectId])

  const handleUploadStart = () => {
    console.log('handleUploadStart');
    setLoading(true);

    API.uploadCrimes().then(
      message => {
        setLoading(false);
        alert(message);
        window.location.reload();
      }
    );
  }

  if (user.isSingIn() === false) {
    return (
      <Switch>
        <Route exact path='/login/userId/:userId/subjectId/:subjectId' component={SignIn} />
        <Route path='/' component={SignIn} />
      </Switch>
    )
  } else return (
    <div>
      <SendingDialog open={isUploading} onClose={() => setLoading(false)} />

      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <Switch>
        {/** Дублирование маршрута /login/ нужно на случай если 
             * авторизованный пользователь снова перейдет по этому маргруту
             * если убрать дублирование то пользователь увидит белый экран
             */}
        <Route exact path='/login/userId/:userId/subjectId/:subjectId' component={SignIn} />
        <Route exact path='/' render={(props) =>
          <div >
            <CrimeList />
            <MyAppBar onSend={handleUploadStart} />
          </div>} />
        <Route exact path='/detail/:mode/:uuid' component={CrimeDetail} />
        <Route exact path='/about/' component={AboutApp} />
      </Switch>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={() => setSnackMsg('')}
        open={Boolean(snackMsg)}
        autoHideDuration={2000}
        message={<span >{snackMsg}</span>} />
    </div >
  )
}
export default App;
